/**
 * OrbPostMachinesWithTraitsPart1VisionAROrbPostMachinesWithTraitsPart1VisionARPage
 *
 * Page component for OrbPostMachinesWithTraitsPart1VisionAROrbPostMachinesWithTraitsPart1VisionARPage
 * Path: /ar/blog/machines-with-traits-part-1-vision
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbPostMachinesWithTraitsPart1VisionARPostPageView as __OrbPostMachinesWithTraitsPart1VisionARPostPageView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionARPostPageView';
import { OrbPostMachinesWithTraitsPart1VisionARPostAnalyticsView as __OrbPostMachinesWithTraitsPart1VisionARPostAnalyticsView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionARPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbPostMachinesWithTraitsPart1VisionAROrbPostMachinesWithTraitsPart1VisionARPageProps {
  // Add any page-level props here
}

export function OrbPostMachinesWithTraitsPart1VisionAROrbPostMachinesWithTraitsPart1VisionARPage(_props: OrbPostMachinesWithTraitsPart1VisionAROrbPostMachinesWithTraitsPart1VisionARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"الآلات بسمات: كيف سيغير المدار مستقبل الروبوتات","description":"تخيل عالماً حيث لا تحتاج لكتابة آلاف الأسطر من الكود لتجعل روبوتاً يتحرك بذكاء. عالماً تُصرّح فيه عن سلوك الآلة بنفس الطريقة التي تصف بها حركة الكواكب في مداراتها.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/blog/machines-with-traits-part-1-vision"},{"locale":"ar","path":"/ar/blog/machines-with-traits-part-1-vision"},{"locale":"sl","path":"/sl/blog/machines-with-traits-part-1-vision"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbPostMachinesWithTraitsPart1VisionARPostPageView config={{ initPayload: __navState }} />
          <__OrbPostMachinesWithTraitsPart1VisionARPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbPostMachinesWithTraitsPart1VisionAROrbPostMachinesWithTraitsPart1VisionARPage;
